import * as Yup from "yup";

export const validationSchema = Yup.object().shape({});

export const coverageSummaryValidationSchema = Yup.object().shape({
    provideManualCoverage: Yup.boolean().nullable(),
    coverageConfirmed: Yup.boolean()
        .nullable()
        .when("provideManualCoverage", {
        is: true,
        then: Yup.boolean().required("Required"),
}),
    provideManualSupplementalCoverage: Yup.boolean().nullable(),
    supplementalCoverageConfirmed: Yup.boolean()
        .nullable().when("provideManualSupplementalCoverage", {
            is: true,
            then: Yup.boolean().required("Required"),
        }),
    coverageForm: Yup.object().when(["provideManualCoverage", "coverageConfirmed"], {
        is: true,
        then: Yup.object().shape({
            companyName: Yup.string()
                .nullable()
                .required("Required"),
            address: Yup.string()
                .nullable()
                .required("Required"),
            phoneNumber: Yup.string()
                .nullable()
                .required("Required"),
            plan: Yup.string()
                .nullable()
                .required("Required"),
            groupNumber: Yup.string()
                .nullable()
                .required("Required"),
            employer: Yup.string()
                .nullable()
                .required("Required"),

            memberId: Yup.string()
                .nullable()
                .required("Required"),
        }),
        otherwise: Yup.object().nullable(),
    }),
    supplementalCoverageForm: Yup.object().when(
        [
            "provideManualCoverage",
            "coverageConfirmed",
            "provideManualSupplementalCoverage",
            "supplementalCoverageConfirmed",
        ],
        {
            is: true,
            then: Yup.object().shape({
                companyName: Yup.string()
                    .nullable()
                    .required("Required"),
                address: Yup.string()
                    .nullable()
                    .required("Required"),
                phoneNumber: Yup.string()
                    .nullable()
                    .required("Required"),
                plan: Yup.string()
                    .nullable()
                    .required("Required"),
                groupNumber: Yup.string()
                    .nullable()
                    .required("Required"),
                employer: Yup.string()
                    .nullable()
                    .required("Required"),

                memberId: Yup.string()
                    .nullable()
                    .required("Required"),
            }),
            otherwise: Yup.object().nullable(),
        }
    ),
});
